import React from 'react';
import styles from './O_PlanRadio.module.css';
import A_RadioItem from '../../A_Atoms/A_RadioItem/A_RadioItem';
import M_Rate from '../../M_Molecules/M_Rate/M_Rate';

interface O_PlanRadioProps {
  name: string;
  price: number;
  isDiscounted: boolean;
  discount: number;
  isActive: boolean;
  onChange?: (value: string) => void;
  value?: string;
  label?: string;
  showPriceSuffix?: boolean;
}

export default function O_PlanRadio({
  name,
  price,
  isDiscounted,
  discount,
  isActive,
  onChange,
  value,
  label,
  showPriceSuffix = true,
}: O_PlanRadioProps) {
  const handleChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <div className={styles.wrapper}>
      <A_RadioItem
        checked={isActive}
        onChange={handleChange}
        value={value ?? name}
        name='subscription-plan'
      />
      <M_Rate
        name={label ?? name}
        price={price}
        isDiscounted={isDiscounted}
        discount={discount}
        isActive={isActive}
        showPriceSuffix={showPriceSuffix}
      />
    </div>
  );
}
